import type {ComplexStyleRule} from '@vanilla-extract/css';
import {px} from './spacing';

const vars = {
    regular: '--font-family-regular',
    /** we probably don't need this one; never used */
    medium: '--font-family-medium',
    bold: '--font-family-bold',
} as const;

export const fontDefinitions = {
    [vars.regular]: '"DMSans Regular", arial, sans-serif',
    /** we probably don't need this one; never used */
    [vars.medium]: '"DMSans Medium", arial, sans-serif',
    [vars.bold]: '"DMSans Bold", arial, sans-serif',
};

export const fontFamily = {
    regular: `var(${vars.regular})`,
    /** we probably don't need this one; never used */
    medium: `var(${vars.medium})`,
    bold: `var(${vars.bold})`,
};

const defineText = (fs: number, lh: number, ls: string) =>
    ({
        regular: {
            font: `${px(fs)}/${px(lh)} ${fontFamily.regular}`,
            letterSpacing: ls,
        },
        bold: {
            font: `${px(fs)}/${px(lh)} ${fontFamily.bold}`,
            letterSpacing: ls,
        },
    }) satisfies Record<string, ComplexStyleRule>;

const defineHeading = (fs: number, lh: number, ls: string) =>
    ({
        font: `${px(fs)}/${px(lh)} var(--font-family-bold)`,
        letterSpacing: ls,
    }) satisfies ComplexStyleRule;

export const text = {
    S: defineText(9, 12, '-0.006em'),
    M: defineText(12, 16, '-0.006em'),
    L: defineText(14, 20, '-0.006em'),
    XL: {
        regular: defineText(16, 20, '-0.01em').regular,
    },
};

export const heading = {
    S: defineHeading(16, 20, '-0.011em'),
    M: defineHeading(20, 24, '-0.017em'),
    L: defineHeading(24, 28, '-0.021em'),
};

export const font = {
    'text-s': text.S.regular,
    'text-s-regular': text.S.regular,
    'text-s-bold': text.S.bold,
    'text-m': text.M.regular,
    'text-m-regular': text.M.regular,
    'text-m-bold': text.M.bold,
    'text-l': text.L.regular,
    'text-l-regular': text.L.regular,
    'text-l-bold': text.L.bold,
    'text-xl': text.XL.regular,
    'text-xl-regular': text.XL.regular,
    'heading-s': heading.S,
    'heading-m': heading.M,
    'heading-l': heading.L,
};
